import { unwrapFieldValue } from 'features/libra/ontology/ontologyFieldDefaults'
import { FieldValues } from 'features/libra/ontology/ontologyFieldTypes'
import { SectionType } from 'features/libra/sections/sectionTypes'

import { ConditionalFormConfig } from './api/conditionalFormApi'
import { getVisibleSectionIds } from './conditionalFormSection/conditionalFormVisibility'

export function isConditionalFormStepComplete(params: {
  config: ConditionalFormConfig
  fieldValues: FieldValues
}): boolean {
  const { config, fieldValues } = params
  const { form, sections } = config
  const visibleSectionIds = getVisibleSectionIds(form, fieldValues ?? {})

  return visibleSectionIds.every((sectionId) => {
    const section = sections.find((s) => s.id === sectionId)
    if (!section) {
      return true
    }

    switch (section.type) {
      case SectionType.FLOWCHART: {
        const flowchartValue = unwrapFieldValue(fieldValues?.[section.id])
        return flowchartValue !== undefined && flowchartValue !== null
      }

      case SectionType.FORM:
        return section.fields.every((field: string) => {
          const value = unwrapFieldValue(fieldValues?.[field])
          return value !== undefined && value !== null && value !== ''
        })

      case SectionType.ARRAY_TABLE:
        // Don't make array tables required for now
        // TODO: Add some control field to determine required vs optional
        return true
    }
  })
}
